import React from "react"
import { useTranslation } from "react-i18next"

const ServiceTags = ({ insurance, transfer, transport }) => {
  const { t } = useTranslation()

  if (!insurance && !transfer && !transport) return null

  return (
    <div className="flex flex-wrap gap-1">
      {insurance && (
        <span className="px-1.5 py-0.5 bg-teal-50   border border-teal-200   text-teal-600   rounded text-[10px]">
          {t("table.insurance_column")}
        </span>
      )}
      {transfer && (
        <span className="px-1.5 py-0.5 bg-purple-50 border border-purple-200 text-purple-600 rounded text-[10px]">
          {t("table.transfer_column")}
        </span>
      )}
      {transport && (
        <span className="px-1.5 py-0.5 bg-sky-50    border border-sky-200    text-sky-600    rounded text-[10px]">
          {t("table.avia_column")}
        </span>
      )}
    </div>
  )
}

export default ServiceTags
